import { isFinite } from 'lodash-es';

/** @see qs.stringify */
export function qsReplacer(_prefix: string, value: unknown) {
    switch (true) {
        case value === undefined:
        case value === null:
            return undefined;
        case typeof value === 'number':
            return isFinite(value) ? value : undefined;
        case typeof value === 'string':
            return String(value).trim() || undefined;
        default:
            return value;
    }
}
